export class Master {
    constructor(
        public id?: number,
        public masterInm?: string,
        public masterLabel?: string,
        public masterHabilitationId?: string,
        public specialityInmp?: string,
        public specialityLabel?: string,
        public specialityHabilitationId?: string,
        public masterUrl?: string,
        public masterSchoolUai?: string,
        public masterSchoolLabel?: string,
        public masterSchoolName?: string,
        public academicRegionLabel?: string,
        public academyCode?: string,
        public academyLabel?: string,
        public residualVacantPlaces?: number,
        public residualVacantPlacesDisplayed?: string,
        public residualVacantPlacesLastModificationDate?: any,
        public attributedPlaces?: number,
        public availablePlaces?: number,
        public availablePlacesDisplayed?: string,
        public formationLabel?: string, // mention + speciality
        public masterTitle?: string,
        public inCart?: boolean,
        public selected?: boolean,
        public createdBy?: string,
        public createdDate?: string,
        public lastModifiedBy?: string,
        public lastModifiedDate?: string,
        public campaign?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master.model.ts